import axios from 'axios'
import router from '../router'
import { clearAuth, getToken } from '../auth/session'

function currentRouteIsPublic() {
  const r = router.currentRoute
  if (!r) return false
  const p = r.path || ''
  if (p === '/login' || p.startsWith('/public/')) {
    return true
  }
  const m = r.matched
  return Array.isArray(m) && m.some((x) => x.meta && x.meta.public)
}

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api'

const http = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
})

http.interceptors.request.use((config) => {
  const t = getToken()
  if (t) {
    config.headers.Authorization = `Bearer ${t}`
  }
  // 默认 Content-Type 为 application/json 时，axios 会把 FormData 转成 JSON，PHP 无法解析 multipart
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    const h = config.headers
    if (h && typeof h.delete === 'function') {
      h.delete('Content-Type')
      h.delete('content-type')
    } else if (h && typeof h === 'object') {
      delete h['Content-Type']
      delete h['content-type']
    }
  }
  return config
})

http.interceptors.response.use(
  (res) => res.data,
  (err) => {
    const status = err.response && err.response.status
    if (status === 401) {
      clearAuth()
      if (!currentRouteIsPublic() && router.currentRoute.path !== '/login') {
        router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } }).catch(() => {})
      }
    }
    const msg =
      (err.response && err.response.data && err.response.data.error) ||
      err.message ||
      '请求失败'
    return Promise.reject(new Error(msg))
  }
)

export default http
